let EDDFileID = null;

export const setEDDFileID = (value) => {
    EDDFileID = value;
};

export const getEDDFileID = () => EDDFileID;